import { Model } from '@/models/Model';
import client from '@/support/Client';
import { DateTime } from 'luxon';
export class DateTimeslotSummary extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'DateTimeslotSummary';
        this.$endpoint = '/datetimeslots/roster';
        this.$fillable = ['starts_at', 'ends_at'];
    }
    get calendarEvents() {
        const calendarEvents = [];
        if (this.data) {
            this.data.forEach((timeslotData) => {
                const calendarEvent = {
                    id: timeslotData.id || '',
                    title: timeslotData.title || '',
                    start: timeslotData.starts_at ? DateTime.fromSQL(timeslotData.starts_at).toISO() : '',
                    end: timeslotData.ends_at ? DateTime.fromSQL(timeslotData.ends_at).toISO() : '',
                    extendedProps: {
                        type: 'date-time-slot',
                        audits: [],
                        events: this.parseEvents(timeslotData),
                        is_valid: timeslotData.is_valid,
                    },
                    className: `slot__event`,
                };
                calendarEvents.push(calendarEvent);
            });
        }
        return calendarEvents;
    }
    load() {
        return client('get', this.$endpoint, { filters: this.filters });
    }
    // public id?: string;
    // public title?: string;
    // public starts_at?: string;
    // public is_valid?: boolean;
    // public ends_at?: string;
    // public events?: EventModel[];
    // get calendarEvents() {
    //   let events: any[] = [];
    //   if(this.data && this.data.length) {
    //     this.data.forEach((currentData: SummaryData) => {
    //       const parsedEvent: CalendarEvent = {
    //         id: currentData.id || '',
    //         title: currentData.title || '',
    //         start: currentData.starts_at ? DateTime.fromSQL(currentData.starts_at).toISO() : '',
    //         end: currentData.ends_at ? DateTime.fromSQL(currentData.ends_at).toISO() : '',
    //         extendedProps: {
    //           type: 'date-time-slot',
    //           events: this.parseEvents(currentData),
    //           is_valid: currentData.is_valid,
    //           audits: this.audits,
    //         },
    //         className: `slot__event`,
    //       }
    //       events.push(parsedEvent);
    //     });
    //   }
    //   return events;
    // }
    audit() {
        const url = this.$endpoint + '/' + this.resolvePrimaryKey() + '/audits';
        return client('get', url, {}).then((response) => {
            return Promise.resolve(response.data);
        }, (error) => {
            return Promise.reject(error);
        });
    }
    parseEvents(data) {
        const parsedEvents = [];
        if (data && data.events && data.events.length) {
            data.events.forEach((eventId) => {
                if (this.meta && this.meta.events) {
                    const event = {
                        id: eventId,
                        type: this.meta.events[eventId].type || '',
                        starts_at: data.starts_at ? DateTime.fromSQL(data.starts_at).toISO() : '',
                        ends_at: data.ends_at ? DateTime.fromSQL(data.ends_at).toISO() : '',
                        room: this.parseRoom(this.meta.events[eventId].room || ''),
                        levels: this.meta.events[eventId].levels ? this.parseLevels((this.meta.events)[eventId].levels || []) : [],
                        groups: this.meta.events[eventId].groups ? this.parseGroups((this.meta.events)[eventId].groups || []) : [],
                        areas: this.meta.events[eventId].areas ? this.parseAreas((this.meta.events)[eventId].areas || []) : [],
                        topics: this.meta.events[eventId].topics ? this.parseTopics((this.meta.events)[eventId].topics || []) : [],
                        subjects: this.meta.events[eventId].subjects ? this.parseSubjects((this.meta.events)[eventId].subjects || []) : [],
                        teacher: this.meta.events[eventId].teacher ? this.parseTeacher((this.meta.events)[eventId].teacher || '') : '',
                        is_chosen: this.meta.events[eventId].is_chosen,
                        is_updated: this.meta.events[eventId].is_updated,
                    };
                    parsedEvents.push(event);
                }
            });
        }
        return parsedEvents;
    }
    parseTeacher(teacherId) {
        if (this.meta && this.meta.teachers && this.meta.teachers[teacherId]) {
            return this.meta.teachers[teacherId];
        }
        return null;
    }
    parseAreas(areas) {
        const parsed = [];
        areas.forEach((areaId) => {
            if (this.meta && this.meta.areas && this.meta.areas[areaId]) {
                parsed.push(this.meta.areas[areaId]);
            }
        });
        return parsed;
    }
    parseTopics(topics) {
        const parsed = [];
        topics.forEach((areaId) => {
            if (this.meta && this.meta.topics && this.meta.topics[areaId]) {
                parsed.push(this.meta.topics[areaId]);
            }
        });
        return parsed;
    }
    parseSubjects(subjects) {
        const parsed = [];
        subjects.forEach((subjectId) => {
            if (this.meta && this.meta.subjects && this.meta.subjects[subjectId]) {
                parsed.push(this.meta.subjects[subjectId]);
            }
        });
        return parsed;
    }
    parseGroups(groups) {
        const parsed = [];
        groups.forEach((group) => {
            if (this.meta && this.meta.groups && this.meta.groups[group.id]) {
                const groupSummary = Object.assign({}, this.meta.groups[group.id]);
                groupSummary.is_mandatory = group.is_mandatory;
                parsed.push(groupSummary);
            }
        });
        return parsed;
    }
    parseLevels(levels) {
        const parsed = [];
        levels.forEach((level) => {
            if (this.meta && this.meta.levels && this.meta.levels[level.id]) {
                const levelSummary = Object.assign({}, this.meta.levels[level.id]);
                levelSummary.is_mandatory = level.is_mandatory;
                parsed.push(levelSummary);
            }
        });
        return parsed;
    }
    parseRoom(roomId) {
        if (this.meta && this.meta.rooms && this.meta.rooms[roomId]) {
            return this.meta.rooms[roomId];
        }
        return null;
    }
}
